
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"170.4","height":"170.4","viewBox":"0 0 45.085 45.085","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.09 22.543c0 12.45-10.092 22.543-22.542 22.543-12.45 0-22.543-10.092-22.543-22.543C.005 10.093 10.098.001 22.548.001S45.09 10.094 45.09 22.543","fill":"#324a5e"}}),_c('path',{attrs:{"d":"M34.09 15.355h1.524c.25 0 .454-.204.454-.454v-3.573a.454.454 0 00-.454-.454H34.09a.454.454 0 00-.454.454V14.9c0 .25.203.454.454.454","fill":"#84dbff"}}),_c('path',{attrs:{"d":"M34.09 20.718h1.524c.25 0 .454-.203.454-.454v-3.573a.454.454 0 00-.454-.454H34.09a.454.454 0 00-.454.454v3.573c0 .25.203.454.454.454","fill":"#ff7058"}}),_c('path',{attrs:{"d":"M34.09 26.081h1.524c.25 0 .454-.204.454-.454v-3.573a.454.454 0 00-.454-.454H34.09a.454.454 0 00-.454.454v3.573c0 .25.203.454.454.454","fill":"#ffd05b"}}),_c('path',{attrs:{"d":"M33.64 7.644H11.451a.97.97 0 00-.97.97v27.859c0 .535.434.97.97.97H33.64a.97.97 0 00.97-.97V8.613a.97.97 0 00-.97-.969","fill":"#fff"}}),_c('path',{attrs:{"d":"M11.45 7.644a.97.97 0 00-.97.97v27.859c0 .535.434.97.97.97h2.859V7.645z","fill":"#4cdbc4"}}),_c('g',{attrs:{"fill":"#e6e9ee"}},[_c('path',{attrs:{"d":"M26.72 15.579c0 1.362-1.07 2.465-2.391 2.465-1.32 0-2.391-1.103-2.391-2.465 0-1.361 1.07-2.465 2.39-2.465 1.322 0 2.392 1.104 2.392 2.465M30.28 23.129v1.24h-11.9v-1.24c0-2.821 1.963-4.15 4.6-4.468l1.35 1.82 1.35-1.82c1.101.134 2.084.442 2.858.963 1.076.726 1.742 1.862 1.742 3.505M31.98 28.946H16.684v-1.11H31.98zM31.98 31.352H16.684v-1.11H31.98zM23.74 32.647h-7.054v1.11h7.054z"}})])])
          )
        }
      }
    